import { useContext } from 'react';
import { i18n } from 'i18n';
import MenuStateContext from './menuStateContext';

const useMenuState = () => {
  const context = useContext(MenuStateContext);
  if (context === null) {
    throw new Error(i18n._('No menuState context available'));
  }
  return context;
};

export default useMenuState;
